<template>
    <!--届け先振り分け設定パーツ-->
    <div class="sh041" id="sh041" v-cloak>
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <div class="section-inner">
            <!--エラーメッセージ表示 -->
            <div class="errMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="SH041_PART"/>
            </div>
            <!-- カート情報 -->
            <div class="itemTitle">
                <h2>{{$t("sh041.labels.cartInfo")}}</h2>
            </div>
            <!-- 商品一覧 ここから  -->
            <div v-if="dataInit.cartInfoList && dataInit.cartInfoList.length>0" class="itemTable" id="cartInfo">
                <div class="itemHeader">
                    <div class="label divNo">
                        <!--No-->
                        <label class="no">{{$t('common.labels.no')}}</label>
                    </div>
                    <div class="label divItemNm">
                        <!-- 商品名 -->
                        <label class="itemNm">{{$t('common.labels.productName')}}</label>
                    </div>
                    <div class="label divPrice" v-if="dataInit.priceShow != 1">
                        <!-- 単価  -->
                        <label class="unitPrice">{{$t('common.labels.unitPrice')}}</label>
                    </div>
                    <div class="label divQty">
                        <!-- カート数量 -->
                        <label class="quantity">{{$t('sh041.labels.cartQuantity')}}</label>
                    </div>
                    <div class="label divTax">
                        <!--振分済数-->
                        <label class="quantity">{{$t('sh041.labels.furiwakeQty')}}</label>
                    </div>
                </div>
                <div class="itemBody">
                    <div v-for="(product, index) in dataInit.cartInfoList" :key="index" class="itemList">
                        <!--No -->
                        <div class="label divNo" :aria-label="$t('common.labels.no')">
                            {{index + 1}}
                        </div>
                        <!--商品名 -->
                        <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                            <div style="display:flex;align-items:center;gap:6px;">
                                <img v-if="dataInit.itemImageShowOption == 1 && common.stringNvl(product.IMG_URL1,'') != ''" :src="product.IMG_URL1" :alt="common.stringNvl(product.WEB_ITEM_NM,'')" @error="getErrImage" class="item-image sh041-item-img">
                                <div>
                                    <router-link :to="{ name: SiteConstants.PG030, params:{pageNo: 3, sItemNo: product.M_ITEM_CD}}">
                                        {{common.stringNvl(product.WEB_ITEM_NM,'')}}
                                    </router-link>
                                    <div v-for="(item, idx) in dataInit.optionList" :key="idx">
                                        <dt v-if="product.SEQ == item.SEQ && product.OPTION_GROUP_CD == item.OP_GP_CD">{{$t(item.OPTION_NAME)}}</dt>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--単価-->
                        <div class="label divPrice" v-if="dataInit.priceShow != 1" :aria-label="$t('common.labels.unitPrice')">
                            <!-- 税込みの場合 -->
                            <span v-if="dataInit.tnkDspKbn == '1'">
                                {{common.formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}
                            </span>
                            <span v-else>
                                {{common.formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}
                            </span>
                        </div>
                        <!--カート数量 -->
                        <div class="label divQty" :aria-label="$t('common.labels.quantity')">
                            <span>{{product.QTY}}</span>
                        </div>
                        <!--振分済数-->
                        <div  class="label divQty" :aria-label="$t('sh041.labels.furiwakeQty')">
                            <span v-if = "product.BINSYU_KBN == '90' " >{{$t('sh041.labels.shopReceipt')}}</span>
                            <span v-else> {{furiwakeQty(product.M_ITEM_CD,product.SEQ)}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 商品一覧 ここまで  -->

            <!-- お届け先ごとに指定してください -->
            <div class="itemTitle">
                <h2>{{$t("sh041.labels.tdkInfoSetting")}}</h2>
            </div>
            <!-- お届け先 ここから  -->
            <div v-if="reqModel.tdkInfoList" class="itemTable" id="tdkInfo">
                <div class="itemBody">
                    <div v-for="(tdk, index) in reqModel.tdkInfoList" :key="index" class="itemList">
                        <!--お届け先 -->
                        <div :id="'tdkInfo_'+index" class="label divTdkNm" :aria-label="$t('sh041.labels.tdkNm')">
                            <span >{{$t("sh041.labels.tdkNm")}}</span>
                            <div>
                                <dt v-if="dataInit.tdkKeisyouPullDownFlg == 0 || (dataInit.tdkKeisyouPullDownFlg == 1 && tdk.tdkFlg == 1)">
                                    {{tdk.tdkNm1}} {{tdk.tdkNm2}} {{tdk.tdkNm3}} {{tdk.tdkTitle}}
                                </dt>
                                <dt v-else class="p-0 mt-1 ml-1" >
                                    {{tdk.tdkNm1}} {{tdk.tdkNm2}} {{tdk.tdkNm3}} 
                                    <select class="p-0" v-model="tdk.tdkTitle" :id="'tdkTitle_'+index">
                                        <option v-for="tdkKeisyou in dataInit.tdkHyoujiKeisyoList" :key="tdkKeisyou.KEY" :value="tdkKeisyou.KEY" :selected="tdkKeisyou.KEY == tdk.tdkTitle">{{tdkKeisyou.VALUE}}</option>
                                    </select>
                                </dt>
                                <!-- 届先・送主情報詳細表示オプションON：注文者と同じ -->
                                <template v-if="dataInit.tdkInfoDetailShowOption === 1 && tdk.tdkFlg == 1">
                                    <p>{{reqModel.kokyakuNm1}} {{reqModel.kokyakuNm2}} {{reqModel.kokyakuNm3}}</p>
                                    <p>〒{{reqModel.kokyakuZip}}</p>
                                    <p>{{reqModel.kokyakuAddr1}}{{reqModel.kokyakuAddr2}}{{reqModel.kokyakuAddr3}}</p>
                                    <p v-if="reqModel.kokyakuTel">TEL：{{reqModel.kokyakuTel}}</p>
                                </template>
                                <!-- 届先・送主情報詳細表示オプションON：別届先 -->
                                <template v-if="dataInit.tdkInfoDetailShowOption === 1 && tdk.tdkFlg == 0">
                                    <p>〒{{tdk.tdkZip}}</p>
                                    <p>{{tdk.tdkAddr1}}{{tdk.tdkAddr2}}{{tdk.tdkAddr3}}</p>
                                    <p v-if="tdk.tdkTel">TEL：{{tdk.tdkTel}}</p>
                                </template>
                            </div>
                        </div>
                        <!--送主 -->
                        <div :id="'tdkOkuriScroll_'+index" class="label divCsmNm" :aria-label="$t('sh041.labels.csmNm')">
                            <span >{{$t("sh041.labels.csmNm")}}</span>
                            <div >
                                <dt v-if="tdk.okuriNushiCheckBox != 1">{{tdk.csmNm}}</dt>
                                <!-- 届先・送主情報詳細表示オプションON：注文者と同じ -->
                                <template v-if="dataInit.tdkInfoDetailShowOption === 1 && tdk.okuriNushiCheckBox != 1">
                                    <p>{{reqModel.kokyakuNm1}} {{reqModel.kokyakuNm2}} {{reqModel.kokyakuNm3}}</p>
                                    <p>〒{{reqModel.kokyakuZip}}</p>
                                    <p>{{reqModel.kokyakuAddr1}}{{reqModel.kokyakuAddr2}}{{reqModel.kokyakuAddr3}}</p>
                                    <p v-if="reqModel.kokyakuTel">TEL：{{reqModel.kokyakuTel}}</p>
                                </template>
                            <!-- 送り主 読み取り専用表示（閉じた状態、オプション50776 ON 時のみ） -->
                            <div v-if="tdk.okuriNushiCheckBox == 1 && dataInit.csmInfoOption == 1 && dataInit.okuriInputKaiheiOption == 1 && !tdk.csmEditOpen" class="sh041-csm-readonly">
                                <!-- BtoC: 名前1行 / BtoB: 会社名+部署・担当者 -->
                                <template v-if="dataInit.siteFlg != 1">
                                    <p>{{tdk.csmNm1}} {{tdk.csmNm2}} {{tdk.csmNm3}}</p>
                                </template>
                                <template v-else>
                                    <p>{{tdk.csmNm1}}</p>
                                    <p v-if="tdk.csmNm2 || tdk.csmNm3">{{tdk.csmNm2}} {{tdk.csmNm3}}</p>
                                </template>
                                <template v-if="dataInit.tdkInfoDetailShowOption === 1">
                                    <p v-if="tdk.csmZip">〒{{tdk.csmZip}}</p>
                                    <p>{{tdk.csmAddr1}}{{tdk.csmAddr2}}{{tdk.csmAddr3}}</p>
                                    <p v-if="tdk.csmTel">TEL：{{tdk.csmTel}}</p>
                                </template>
                            </div>
                                <label v-if="dataInit.csmInfoOption == 1" :for="'okuriNushiCheckBox_'+index" class="select_add">
                                <input type="checkbox" :id="'okuriNushiCheckBox_'+index" true-value="1" false-value="0" v-model="tdk.okuriNushiCheckBox" 
                                    @change="onCsmCheckChange(tdk)"
                                    class="sh041-inpCsmNm">
                                <!-- 別の送主を指定する -->
                                <b>{{$t("sh041.buttons.changeCsm")}}</b>
                            </label>
                            <!-- 送り主の内容を編集ボタン（オプション50776 ON 時のみ） -->
                            <button v-if="dataInit.okuriInputKaiheiOption == 1 && tdk.okuriNushiCheckBox == 1 && !tdk.csmEditOpen"
                                    type="button" class="sh041-btn-csm-edit"
                                    @click="tdk.csmEditOpen = true">送り主の内容を編集</button>
                            </div>
                        </div>

                        <!--送り主（BtoC） -->
                        <div class="sh041-body-okurinushi-area" id="hide_table_4" v-if="tdk.okuriNushiCheckBox ==  1 && dataInit.csmInfoOption == 1 && dataInit.siteFlg != 1 && (dataInit.okuriInputKaiheiOption != 1 || tdk.csmEditOpen)">
                            <div class="sh041-body-subtitle">
                                <h4>送主情報</h4>
                                <!--送り主を一括反映-->
                                <button class="sh041-tdk-btn2" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="setIkkatuOkuriInfo(index)">
                                    {{$t("sh041.buttons.okurihanei")}}
                                </button>
                            </div>
                            <table class="sh041-body-order-tbl-person" >
                                <tr>
                                    <th class="sh041-th-name required">
                                        <!-- お名前※ -->
                                        {{$t("sh030.labels.name")}}
                                    </th>
                                    <td>
                                        <div class="sh041-form-column left ">
                                            <input type="hidden" v-model="tdk.csmNo">
                                            <!-- 姓 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            </template>
                                            <template v-else>
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用しない場合-->
                                            <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                <input-check type="text" :id="'csmNm1_'+index" :name="'csmNm1_'+index"
                                                        v-model="tdk.csmNm1" size="20"
                                                        maxlength="50" class="sh041-inp-csmNm1" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmNm1}"/>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用する場合-->
                                            <template v-else>
                                                <input-check type="text" :id="'csmNm1_'+index" :name="'csmNm1_'+index"
                                                        disabled
                                                        v-model="tdk.csmNm1" size="20" 
                                                        maxlength="50" class="sh041-inp-csmNm1"/>
                                            </template>
                                            <!-- 名2 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                    <input-check type="text" :id="'csmNm2_'+index" :name="'csmNm2_'+index"
                                                                v-model="tdk.csmNm2" size="20"
                                                                maxlength="50" class="sh041-inp-csmNm2"/>
                                                </template>
                                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                                <template v-else>
                                                    <input-check type="text" :id="'csmNm2_'+index" :name="'csmNm2_'+index"
                                                                disabled 
                                                                v-model="tdk.csmNm2" size="20"
                                                                maxlength="50" class="sh041-inp-csmNm2"/>
                                                </template>
                                            </template>
                                        </div>
                                        <!-- 送主を検索-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="searchOkuriNushiList(index)">{{$t("sh030.labels.okuriAddressee")}}</button>
                                        <!-- 注文者情報を反映-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="setKokyakuInfo(index)">{{$t("sh041.buttons.setKokyaku")}}</button>
                                        <br />
                                        <div v-html="descriptionInfo[17]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- フリガナ -->
                                    <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.nameKana")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.nameKana")}}</th>
                                    <td>
                                        <div class="sh041-form-column">
                                            <!-- 姓 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.surname")}}</label>
                                            </template>
                                            <template v-else>
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name1")}}</label>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用しない場合-->
                                            <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                <input-check type="text" :id="'csmKana1_'+index" :name="'csmKana1_'+index"
                                                        v-model="tdk.csmKana1" size="20"
                                                        maxlength="50" class="sh041-inp-csmKana1" :class="{'sh041-err-input': tdk.csmOkError && dataInit.kanaHissuFlg == 1 && !tdk.csmKana1}"/>
                                            </template>
                                            <!--配送先名を自分宛にするフラグを利用する場合-->
                                            <template v-else>
                                                <input-check type="text" :id="'csmKana1_'+index" :name="'csmKana1_'+index"
                                                        disabled
                                                        v-model="tdk.csmKana1" size="20"
                                                        maxlength="50" class="sh041-inp-csmKana1"/>
                                            </template>
                                            <!-- 名 -->
                                            <template v-if="dataInit.name2Flg == 1">
                                                <label class="sh041-form-column-num02">{{$t("pt330.labels.name2")}}</label>
                                                <!--配送先名を自分宛にするフラグを利用しない場合-->
                                                <template v-if="dataInit.tdkMyAddrFlg == 0">
                                                    <input-check type="text" :id="'csmKana2_'+index" :name="'csmKana2_'+index"
                                                            v-model="tdk.csmKana2" size="20"
                                                            maxlength="50" class="sh041-inp-csmKana2"/>
                                                </template>
                                                <!--配送先名を自分宛にするフラグを利用する場合-->
                                                <template v-else>
                                                    <input-check type="text" :id="'csmKana2_'+index" :name="'csmKana2_'+index"
                                                            disabled 
                                                            v-model="tdk.csmKana2" size="20"
                                                            maxlength="50" class="sh041-inp-csmKana2"/>
                                                </template>
                                            </template>
                                            <br/>
                                        </div>
                                        <div v-html="descriptionInfo[18]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 郵便番号 -->
                                        {{$t("common.labels.postalCode")}}
                                    </th>
                                    <td ontouchstart="">
                                        <input-check type="text" :id="'csmZip_'+index" :name="'csmZip_'+index" 
                                            v-model="tdk.csmZip" size="13" maxlength="8" class="zip sh041-inp-csmZip" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmZip}" @on-input-change="setAddr(index)"/>
                                        <!-- 住所自動入力 -->
                                        <button class="sh041-btn-csmZip" @click="setAddr(index)"> {{$t("common.labels.addressSearch")}}</button>
                                        <div v-html="descriptionInfo[19]"></div>
                                    </td>
                                </tr>
                                <!-- 都道府県 -->
                                <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <tr>
                                        <th class="required">
                                            <!-- 都道府県 -->
                                            {{$t("sh030.labels.prefectures")}}
                                        </th>
                                        <td>
                                            <select v-model="tdk.csmKen" :id="'csmKen_'+index" class="sh041-sel-csmKen" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmKen}">
                                                <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == tdk.csmKen">{{ken.VALUE}}</option>
                                            </select>
                                            <br>
                                            <div v-html="descriptionInfo[20]"></div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <input type="hidden" :id="'csmKen_'+index" v-model="tdk.csmKen" />
                                </template>
                                <tr>
                                    <!-- 住所（市区郡町村） -->
                                    <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                                    <td>
                                        <input-check :id="'csmAddr1_'+index" type="text" :name="'csmAddr1_'+index" size="50" 
                                            class="sh041-inp-csmAddr1" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmAddr1}"
                                            v-model="tdk.csmAddr1" maxlength="100"/>
                                        <br/>
                                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                                            <div v-html="descriptionInfo[21]"></div>
                                        </template>
                                        <template v-else>
                                            <div v-html="descriptionInfo[22]"></div>
                                        </template>
                                    </td>
                                </tr>
                                <!-- 住所（番地以下） -->
                                <tr v-if="dataInit.addr2Flg == 1">
                                    <th v-if="dataInit.addr2HissuFlg == 1" class="required">{{$t("sh030.labels.streetAddress")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                                    <td>
                                        <input :id="'csmAddr2_'+index" type="text" :name="'csmAddr2_'+index" 
                                            class="sh041-inp-csmAddr2" :class="{'sh041-err-input': tdk.csmOkError && dataInit.addr2HissuFlg == 1 && !tdk.csmAddr2}"
                                            size="50" v-model="tdk.csmAddr2" maxlength="100"/><br/>
                                        <div v-html="descriptionInfo[23]"></div>
                                    </td>
                                </tr>
                                <!-- 住所（マンション名・会社名等） -->
                                <tr v-if="dataInit.addr3Flg == 1">
                                    <th v-if="dataInit.addr3HissuFlg == 1" class="required">{{$t("sh030.labels.apartmentName")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                                    <td>
                                        <input :id="'csmAddr3_'+index" type="text" :name="'csmAddr3_'+index" size="50"
                                            class="sh041-inp-csmAddr3" :class="{'sh041-err-input': tdk.csmOkError && dataInit.addr3HissuFlg == 1 && !tdk.csmAddr3}"
                                            v-model="tdk.csmAddr3" maxlength="100"/><br/>
                                        <div v-html="descriptionInfo[24]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 電話番号※ -->
                                        {{$t("sh030.labels.phoneNumber※")}}
                                    </th>
                                    <td>
                                        <input-check type="text" :id="'csmTel_'+index" :name="'csmTel_'+index" 
                                            class="sh041-inp-csmTel" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmTel}"
                                            v-model="tdk.csmTel" size="20" maxlength="15"/>
                                        <br>
                                        <div v-html="descriptionInfo[25]"></div>
                                    </td>
                                </tr>
                            </table>
                            <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                            <p  class="mb64 input-p-desc-css">
                                <span v-html="descriptionInfo[31]"></span>
                            </p>
                            <!-- 送り主入力欄OKボタン（オプション50776 ON 時のみ） -->
                            <div v-if="dataInit.okuriInputKaiheiOption == 1" class="sh041-csm-ok-area">
                                <span v-if="tdk.csmOkError" class="text-danger sh041-csm-ok-error">未入力の必須項目があります</span>
                                <button type="button" class="sh041-btn-csm-ok" @click="closeCsmEdit(tdk, index)">OK</button>
                            </div>
                        </div>
                        <!--送り主（BtoB） -->
                        <div class="sh041-body-okurinushi-area" id="hide_table_4" v-if="tdk.okuriNushiCheckBox ==  1 && dataInit.csmInfoOption == 1  && dataInit.siteFlg == 1 && (dataInit.okuriInputKaiheiOption != 1 || tdk.csmEditOpen)">
                            <div class="sh041-body-subtitle"><h4>送主情報</h4></div>
                            <table class="sh041-body-order-tbl-person" >
                                <tr>
                                    <th class="required">
                                        <!-- 会社名 -->
                                        {{$t("sh030.labels.okurikaisyame")}}
                                    </th>
                                    <td>
                                        <div class="sh041-div-csmNm1">
                                            <input type="hidden" v-model="tdk.csmNo">
                                            <input-check type="text" :id="'csmNm1_'+index" :name="'csmNm1_'+index"
                                                    v-model="tdk.csmNm1" size="50"
                                                    maxlength="50" class="sh041-inp-csmNm1" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmNm1}"/>
                                        </div>
                                        <!-- 届先を検索-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="searchOkuriNushiList(index)">{{$t("sh030.labels.okuriAddressee")}}</button>
                                        <!-- 注文者情報を反映-->
                                        <button class="sh041-tdk-btn" type="button" v-if="dataInit.kokyakuNo != 999999999"
                                        @click="setKokyakuInfo(index)">{{$t("sh041.buttons.setKokyaku")}}</button>
                                        <br />
                                        <span v-html="descriptionInfo[3]"></span>
                                    </td>
                                </tr>
                                <tr>
                                    <!-- 会社名カナ -->
                                    <th v-if="dataInit.kanaHissuFlg == 1" class="required">{{$t("sh030.labels.kaisyamekana")}}</th>
                                    <th v-else class="optional">{{$t("sh030.labels.okurikaisyamekana")}}</th>
                                    <td>
                                        <div class="sh041-form-column">
                                            <!--配送先名を自分宛にするフラグを利用しない場合-->
                                            <input-check type="text" :id="'csmKana1_'+index" :name="'csmKana1_'+index"
                                                class="sh041-inp-csmKana1" :class="{'sh041-err-input': tdk.csmOkError && dataInit.kanaHissuFlg == 1 && !tdk.csmKana1}"
                                                v-model="tdk.csmKana1" size="50"
                                                maxlength="50" />
                                            <br/>
                                        </div>
                                        <span v-html="descriptionInfo[4]"></span>
                                    </td>
                                </tr>
                                <!-- 部署名 -->
                                <tr>
                                    <th class="optional">{{$t("sh030.labels.bushoName")}}</th>
                                    <td>
                                        <input :id="'csmNm2_'+index" type="text" :name="'csmNm2_'+index" size="50" 
                                            class="sh041-inp-csmNm2"
                                            v-model="tdk.csmNm2" maxlength="50"/><br/>
                                        <span v-html="descriptionInfo[41]"></span>
                                    </td>
                                </tr>
                                <!-- 担当者名 -->
                                <tr>
                                    <th class="optional">{{$t("sh030.labels.tantoshame")}}</th>
                                    <td>
                                        <input :id="'csmNm3_'+index" type="text" :name="'csmNm3_'+index" size="50" 
                                            class="sh041-inp-csmNm3"
                                            v-model="tdk.csmNm3" maxlength="50"/><br/>
                                        <span v-html="descriptionInfo[42]"></span>
                                    </td>
                                </tr>
                                <!-- 表示敬称 -->
                                <tr>
                                    <th class="required">
                                        <!-- 表示敬称 -->
                                        {{$t("sh030.labels.hyoujiKeisyo")}}
                                    </th>
                                    <td>
                                        <select v-model="tdk.csmTitle" :id="'csmTitle_'+index" class="sh041-sel-csmTitle">
                                            <option v-for="ken in dataInit.okuriHyoujiKeisyoList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == tdk.csmTitle">{{ken.VALUE}}</option>
                                        </select>
                                        <br>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 郵便番号 -->
                                        {{$t("common.labels.postalCode")}}
                                    </th>
                                    <td ontouchstart="">
                                        <input-check type="text" :id="'csmZip_'+index" :name="'csmZip_'+index" 
                                            class="zip sh041-inp-csmZip" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmZip}"
                                            v-model="tdk.csmZip" size="13" maxlength="8" @on-input-change="setAddr(index)"/>
                                        <!-- 住所自動入力 -->
                                        <button  @click="setAddr(index)"> {{$t("common.labels.addressSearch")}}</button>
                                        <div v-html="descriptionInfo[19]"></div>
                                    </td>
                                </tr>
                                <!-- 都道府県 -->
                                <template v-if="dataInit.kenPulldownDispFlg == 1">
                                    <tr>
                                        <th class="required">
                                            <!-- 都道府県 -->
                                            {{$t("sh030.labels.prefectures")}}
                                        </th>
                                        <td>
                                            <select v-model="tdk.csmKen" :id="'csmKen_'+index" class="sh041-sel-csmKen" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmKen}">
                                                <option v-for="ken in dataInit.kenList" :key="ken.KEY" :value="ken.KEY" :selected="ken.KEY == tdk.csmKen">{{ken.VALUE}}</option>
                                            </select>
                                            <br>
                                            <div v-html="descriptionInfo[20]"></div>
                                        </td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <input type="hidden" v-model="tdk.csmKen" />
                                </template>
                                <tr>
                                    <!-- 住所（市区郡町村） -->
                                    <th class="required">{{$t("sh030.labels.cityAndCounty")}}</th>
                                    <td>
                                        <input-check :id="'csmAddr1_'+index" type="text" :name="'csmAddr1_'+index" size="50"
                                            class="sh041-inp-csmAddr1" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmAddr1}"
                                            v-model="tdk.csmAddr1" maxlength="50"/>
                                        <br/>
                                        <template v-if="dataInit.kenPulldownDispFlg == 1">
                                            <div v-html="descriptionInfo[21]"></div>
                                        </template>
                                        <template v-else>
                                            <div v-html="descriptionInfo[22]"></div>
                                        </template>
                                    </td>
                                </tr>
                                <!-- 住所（番地以下） -->
                                <tr v-if="dataInit.addr2Flg == 1">
                                    <th class="optional">{{$t("sh030.labels.streetAddress")}}</th>
                                    <td>
                                        <input :id="'csmAddr2_'+index" type="text" :name="'csmAddr2_'+index" size="50" 
                                            class="sh041-inp-csmAddr2"
                                            v-model="tdk.csmAddr2" maxlength="50"/><br/>
                                        <div v-html="descriptionInfo[23]"></div>
                                    </td>
                                </tr>
                                <!-- 住所（マンション名・会社名等） -->
                                <tr v-if="dataInit.addr3Flg == 1">
                                    <th class="optional">{{$t("sh030.labels.apartmentName")}}</th>
                                    <td>
                                        <input :id="'csmAddr3_'+index" type="text" :name="'csmAddr3_'+index" size="50" 
                                            class="sh041-inp-csmAddr3"
                                            v-model="tdk.csmAddr3" maxlength="50"/><br/>
                                        <div v-html="descriptionInfo[24]"></div>
                                    </td>
                                </tr>
                                <tr>
                                    <th class="required">
                                        <!-- 電話番号※ -->
                                        {{$t("sh030.labels.phoneNumber※")}}
                                    </th>
                                    <td>
                                        <input-check type="text" :id="'csmTel_'+index" :name="'csmTel_'+index" 
                                            class="sh041-inp-csmTel" :class="{'sh041-err-input': tdk.csmOkError && !tdk.csmTel}"
                                            v-model="tdk.csmTel" size="20" maxlength="15" />
                                        <br>
                                        <div v-html="descriptionInfo[25]"></div>
                                    </td>
                                </tr>
                            </table>
                            <!-- こちらの住所は今回のご注文でのみ有効です。（会員登録の住所変更手続きはされません。) -->
                            <p  class="mb64 input-p-desc-css">
                                <span v-html="descriptionInfo[31]"></span>
                            </p>
                            <!-- 送り主入力欄OKボタン（オプション50776 ON 時のみ） -->
                            <div v-if="dataInit.okuriInputKaiheiOption == 1" class="sh041-csm-ok-area">
                                <span v-if="tdk.csmOkError" class="text-danger sh041-csm-ok-error">未入力の必須項目があります</span>
                                <button type="button" class="sh041-btn-csm-ok" @click="closeCsmEdit(tdk, index)">OK</button>
                            </div>
                        </div>
                        <br>
                        <!--商品情報-->
                        <div class="divPrice">
                            <!-- 商品一覧 ここから  -->
                            <div v-if="tdk.itemList.length > 0" class="itemTable" id="cart">
                                <div class="itemHeader dt-row">
                                    <div class="label divNo">
                                        <!--No-->
                                        <label class="no">{{$t('common.labels.no')}}</label>
                                    </div>
                                    <div class="label divItemNm ">
                                        <!-- 商品名 -->
                                        <label class="itemNm">{{$t('common.labels.productName')}}</label>
                                    </div>
                                    <!--単価-->
                                    <div class="label divPrice" v-if="dataInit.priceShow != 1 && dataInit.itemPriceShowOption == 1">
                                        <label class="unitPrice">{{$t('common.labels.unitPrice')}}</label>
                                    </div>
                                    <div class="label divQty">
                                        <!-- 数量 -->
                                        <label class="quantity ">{{$t('common.labels.quantity')}}</label>
                                    </div>
                                    <div class="label divNoshi" v-if="dataInit.noshiButtonShowFlg == 1">
                                        <!--のし-->
                                        <label class="noshi">{{$t('sh041.labels.noshi')}}</label>
                                    </div>
                                    <div class="label productZaikoConf " v-if="tdk.displayHanbaiSuuFlg != 0 && dataInit.hanbaiSuuBtnShowOption == 1">
                                        <!-- 商品在庫を見る -->
                                    </div>
                                </div>
                                <div class="itemBody">
                                    <div v-for="(product, pindex) in tdk.itemList" :key="pindex" class="itemList dt-row">
                                        <!--No --><!--受取商品非表示 -->
                                        <div v-show="product.binsyuKbn != '90'" class="label divNo" :aria-label="$t('common.labels.no')">
                                            {{pindex + 1}}
                                        </div>
                                        <!--商品名 --><!--受取商品非表示 -->
                                        <div v-show="product.binsyuKbn != '90'" class="label divItemNm" :aria-label="$t('common.labels.productName')">
                                            <div style="display:flex;align-items:center;gap:6px;">
                                                <img v-if="dataInit.itemImageShowOption == 1 && common.stringNvl(product.imgUrl1,'') != ''" :src="product.imgUrl1" :alt="common.stringNvl(product.itemNm,'')" @error="getErrImage" class="item-image sh041-item-img">
                                                <div>
                                                    {{common.stringNvl(product.itemNm,'')}}
                                                    <div class="divNoshiInfo" v-if="product.qtySelected > 0">{{common.stringNvl(product.noshiInfo,'')}}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!--単価--><!--受取商品非表示 -->
                                        <div v-show="product.binsyuKbn != '90'" class="label divPrice" v-if="dataInit.priceShow != 1 && dataInit.itemPriceShowOption == 1" style="margin-right:16px" :aria-label="$t('common.labels.unitPrice')">
                                            <!-- 税込みの場合 -->
                                            <span v-if="dataInit.tnkDspKbn == '1'">
                                                {{$t('common.labels.unitPrice')}}：{{common.formatPrice(product.saleZeiKTnk)}}{{$t('common.labels.jpYen')}}
                                            </span>
                                            <span v-else>
                                                {{$t('common.labels.unitPrice')}}：{{common.formatPrice(product.saleTnk)}}{{$t('common.labels.jpYen')}}
                                            </span>
                                        </div>
                                        <!--数量 --><!--受取商品非表示 -->
                                        <!--カート分割対応 便種が店頭受取の場合、数量を変更不可に設定 -->
                                        <!--オプション50540: 0=テキスト / 1=プルダウン（デフォルト） / 2=+−ボタン / 3:非表示 -->
                                        <div v-show="product.binsyuKbn != '90'" class="label divQty" :aria-label="$t('common.labels.quantity')">
                                            <!--テキスト入力（puldownFlg == 0）-->
                                            <template v-if="dataInit.puldownFlg == 0">
                                                <span class="sh041-qty-label">{{$t('common.labels.quantity')}}：</span>
                                                <input-check type="text" class="sh041-inp-qty-text num" maxlength="5"
                                                    v-model="product.qtySelected"
                                                    :name="'qty_'+index+'_'+pindex" :id="'qty_'+index+'_'+pindex"
                                                    @on-change="changeQtyDebounced(index,pindex,product.qtySelected)" />
                                            </template>
                                            <!--＋－ボタン＆テキスト入力（puldownFlg == 2）-->
                                            <template v-else-if="dataInit.puldownFlg == 2">
                                                <span class="sh041-qty-label">{{$t('common.labels.quantity')}}：</span>
                                                <label class="numberSpinnerWrap">
                                                    <input-check type="text" class="sh041-inp-qty-text num" maxlength="5"
                                                        v-model="product.qtySelected"
                                                        :name="'qty_'+index+'_'+pindex" :id="'qty_'+index+'_'+pindex"
                                                        @on-change="changeQtyDebounced(index,pindex,product.qtySelected)" />
                                                    <span class="spinner spinnerDown" @click="stepDown(index,pindex)">－</span>
                                                    <span class="spinner spinnerUp" @click="stepUp(index,pindex)">＋</span>
                                                </label>
                                            </template>
                                            <!--プルダウン（puldownFlg == 1 またはデフォルト）-->
                                            <template v-else>
                                                <span class="sh041-qty-label">{{$t('common.labels.quantity')}}：</span>
                                                <select class="sh041-sel-qty" v-model="product.qtySelected"
                                                    :disabled="product.binsyuKbn=='90'"
                                                    @change="changeQty(index,pindex,product.qtySelected)"
                                                    :name="'qty_'+index+'_'+pindex" :id="'qty_'+index+'_'+pindex">
                                                    <option v-for="qty in getQtyOptions(product)" :key="qty" :value="qty">{{qty}}</option>
                                                </select>
                                            </template>
                                        </div>
                                        <!--出荷単位の注意文言--><!--受取商品非表示 -->
                                        <div v-show="product.binsyuKbn != '90'" v-if="product.syukkaNum > 1" class="sh041-qty-limit-info">
                                            <p class="inOneDes"><span>※{{product.syukkaNum}}</span>個ずつのみ注文可能とさせていただきます</p>
                                        </div>
                                        <!--のし--><!--受取商品非表示 -->
                                        <div v-show="product.binsyuKbn != '90'" v-if="dataInit.noshiButtonShowFlg == 1" class="label divNoshi" :aria-label="$t('sh041.labels.noshi')">
                                            <input v-if="product.noshiNgKbn == '0'" type="button" 
                                                class="sh041-inp-qty"
                                                :disabled =" product.qtySelected == 0"
                                                @click="doSetShiNo(tdk.tdkSeq,product.itemCd,product.qtySelected,product.itemNm)" 
                                                :value="$t('common.buttons.changeNoshi')">
                                        </div>
                                        
                                        <div v-show="product.binsyuKbn != '90'" class="label productZaikoConf " v-if="tdk.displayHanbaiSuuFlg != 0 && dataInit.hanbaiSuuBtnShowOption == 1">
                                            <!-- 商品在庫を見る --><!--受取商品非表示 -->
                                            <span v-if="product.displayFlg === 1">
                                                    <a href="#" @click.prevent="showModal(product.itemCd,product.itemNm)" >{{$t('common.labels.productZaikoConf')}}</a>
                                                    <ModalComponent
                                                    v-if="isModalVisible"
                                                    :show="isModalVisible"
                                                    :tableData="tableData"
                                                    :selectedShouhin="selectedShouhin"
                                                    :selectedShouhinLst="selectedShouhinLst"
                                                    :note="note"
                                                    @close="isModalVisible = false"/>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 商品一覧 ここまで  -->
                        </div>
                        
                    </div>
                </div>
            </div>
            <!-- お届け先 ここまで  -->

            <!-- 送り主入力欄 一括ボタン（オプション50776 ON 時のみ・複数届先の場合のみ） -->
            <div v-if="dataInit.okuriInputKaiheiOption == 1 && dataInit.csmInfoOption == 1 && reqModel.tdkInfoList && reqModel.tdkInfoList.length > 1" class="sh041-csm-bulk-area">
                <button v-if="csmCheckedCount > 0 && !allCsmEditClosed" type="button" class="sh041-btn-csm-bulk" @click="closeAllCsmEdit">
                    送り主の入力欄を全て閉じる
                </button>
                <button v-if="csmCheckedCount > 0 && !allCsmEditOpen" type="button" class="sh041-btn-csm-bulk" @click="openAllCsmEdit">
                    送り主の入力欄を全て開く
                </button>
            </div>

            <div class="btnSubmitsh041">
                <!-- 前ページに戻る -->
                <li><button class="sh041-btn-back" @click="goBack" type="button">{{$t("common.buttons.backtothepreviouspage")}}</button></li>
                <!-- 次へ -->
                <li><button class="sh041-btn-next" @click="doNext" type="button">
                    {{ dataInit.stepBasedFlg == 1 ? $t("common.buttons.proceedNext") : $t("common.buttons.change") }}
                </button></li>
            </div>
        </div>
        
        
        <span style="display:none" id="name_lbl">{{$t("sh041.labels.name")}}</span>
        <span style="display:none" id="nameKana_lbl">{{$t("sh041.labels.nameKana")}}</span>
        <span style="display:none" id="nameComp_lbl">{{$t("sh041.labels.kaisyame")}}</span>
        <span style="display:none" id="nameKanaComp_lbl">{{$t("sh041.labels.kaisyamekana")}}</span>
        <span style="display:none" id="mail_lbl">{{$t("sh041.labels.deliveryMailAddress")}}</span>
        <!-- 都道府県 -->
        <span style="display:none" id="prefectures_lbl">{{$t('sh041.labels.prefectures')}}</span>
        <!-- 郵便番号 -->
        <span style="display:none" id="postalCode_lbl">{{$t('sh041.labels.postalCode')}}</span>
        <!-- 電話番号 -->
        <span style="display:none" id="phoneNumber_lbl">{{$t('common.labels.phoneNumber')}}</span>
        <!-- 営業所コード -->
        <span style="display:none" id="yaOfficeCd_lbl">{{$t('sh041.labels.yaOfficeCd')}}</span>
        <alert-confirm
            v-if="isZipMsgAlert"
            :msgConfirm="zipMsg"
            :isButtonCancel="false"
            :okAction="isZipRequiredMsgClose"
            @closedModal="isZipMsgAlert=false"
        ></alert-confirm>

        <alert-confirm
            v-if="isItemCntZeroMsgAlert"
            :msgConfirm="itemCntZeroMsg"
            :isButtonCancel="true"
            :okAction="submit"
            @closedModal="isItemCntZeroMsgAlert=false"
            size="md"
        ></alert-confirm>

        <b-modal v-model="isUpdCartQtyAlert"
            size="lg"
            :title="$t('sh041.labels.qtyConfirm')" 
            no-close-on-backdrop
            centered>
            <div class="sh041-alert-message" >
                <li class="text-danger">{{$t('sh041.messages.updateCartQty')}}</li>
            </div>
            <div class="updCartQtyAlert col-12 mb-1">
                <div class="itemHeader">
                    <div class="label divNo">
                        <!--No-->
                        <label class="no">{{$t('common.labels.no')}}</label>
                    </div>
                    <div class="label divItemNm">
                        <!-- 商品名 -->
                        <label class="itemNm">{{$t('common.labels.productName')}}</label>
                    </div>
                    <div class="label divQty">
                        <!-- カート数量 -->
                        <label class="quantity">{{$t('sh041.labels.cartQuantity')}}</label>
                    </div>
                    <div class="label divTax">
                        <!--振分済数-->
                        <label class="quantity">{{$t('sh041.labels.furiwakeQty')}}</label>
                    </div>
                </div>
                <div v-for="(product, index) in dataInit.cartInfoList" :key="index" class="itemList">
                    <!--No -->
                    <div class="label divNo" :aria-label="$t('common.labels.no')">
                        {{index + 1}}
                    </div>
                    <!--商品名 -->
                    <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                        <router-link :to="{ name: SiteConstants.PG030, params:{pageNo: 3, sItemNo: product.M_ITEM_CD}}">
                            {{common.stringNvl(product.WEB_ITEM_NM,'')}}
                        </router-link>
                        <div v-for="(item, idx) in dataInit.optionList" :key="idx">
                            <dt v-if="product.SEQ == item.SEQ && product.OPTION_GROUP_CD == item.OP_GP_CD">{{$t(item.OPTION_NAME)}}</dt>
                        </div>
                    </div>
                    <!--カート数量 -->
                    <div class="label divQty" :aria-label="$t('common.labels.quantity')">
                        <span>{{product.QTY}}</span>
                    </div>
                    <!--振分済数-->
                    <div  class="label divQty" :aria-label="$t('sh041.labels.furiwakeQty')">
                        <span v-if = "product.BINSYU_KBN == '90' " >{{$t('sh041.labels.shopReceipt')}}</span>
                        <span v-else> {{furiwakeQty(product.M_ITEM_CD,product.SEQ)}}</span>
                    </div>
                </div>
            </div>
            <div slot="modal-footer" class="sh041-footer w-100">
                <div class="sh041-modal-footer text-center">
                    <!-- 更新する -->
                    <li><input class="sh041-model-btn-upd" @click="updCartQty()" :value="$t('common.buttons.update')" type="button"></li>
                    <!-- キャンセル -->
                    <li><input class="sh041-model-btn-cencel" @click="isUpdCartQtyAlert=false;" :value="$t('common.buttons.cancel')" type="button"></li>
                </div>
            </div>
        </b-modal>

        <alert-confirm
            v-if="isItemCntZeroOfOneTdkMsgAlert"
            :msgConfirm="itemCntZeroOfOneTdkMsg"
            :isButtonCancel="false"
            @closedModal="isItemCntZeroOfOneTdkMsgAlert=false"
            size="md"
        ></alert-confirm>
    
        <alert-confirm
            v-if="isErrorAlert"
            :msgConfirm="errorMsg"
            :isButtonCancel="false"
            @closedModal="isErrorAlert=false"
            size="md"
        ></alert-confirm>

        <CC212InputPostal v-if="isCCInputPostalShow" @modal-close="isCCInputPostalShow = false" :propTdkZip1="cc212Prop.propTdkZip1" 
            :propTdkZip2="cc212Prop.propTdkZip2" :propIdx="cc212Prop.propIdx" @set-addr-value="setAddrValue" />
        <CC211SearchOkuriNushiList v-if="isSearchOkurinushiList" @modal-close="isSearchOkurinushiList = false" 
            :propKokyakuNo="cc211Prop.propKokyakuNo" :propTdkKbn="1" :listType="1" @set-addr-value="setOkurinushiValueCc211" />
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import Loading from 'vue-loading-overlay';
import InputCheck from "components/InputCheck";
import InputNumber from 'components/InputNumber';
import AlertConfirm from "components/AlertConfirm";
import mapInfo from "assets/js/mapInfo";
import EventBus from "assets/js/eventBus";
import SiteConstants from 'assets/const/SiteConstants.json';
import Message from 'components/MessageEcSite';
import CC212InputPostal from '../search/CC212InputPostal';
import CC211SearchOkuriNushiList from '../search/CC211SearchTdkList';
import CC215SearchDairiList from '../search/CC215SearchDairiList';
import ModalComponent from '../popup/HanbaiSuuSettingPopup.vue';
import _ from 'lodash';

export default {
    /* 
    * Name of component
    */
    name: "SH041ShopperTdkInfoSetting",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /* 
    * Declare components
    */
    components: {
        InputCheck,
        InputNumber,
        Loading,
        AlertConfirm,
        Message,
        CC212InputPostal,
        CC211SearchOkuriNushiList,
        CC215SearchDairiList,
        ModalComponent
    },/* 
    * Declare variable and set default value
    */
    data() {
        return {
            totalRecord: 50,
            fromRecord: 1,
            toRecord: 10,
            pageSize: 10,
            pageNo: 1,
            goto: 0,
            common: common,
            dataInit:{
                descriptionInfo:{}
            },
            radioGroup:"",
            siteFlg:0,
            reqModel:{},
            isModalVisible: false,
            tableData: [],
            selectedShouhinLst : [],
            selectedShouhin: '',
            note: '',
            mapInfoResp:{},
            mapInfoChangeTdkFlag:false,
            isUpdCartQtyAlert:false,
            isZipMsgAlert:false,
            isItemCntZeroMsgAlert:false,
            isItemCntZeroOfOneTdkMsgAlert:false,
            isErrorAlert:false,
            zipMsg:"",
            itemCntZeroMsg:"",
            itemCntZeroOfOneTdkMsg:"",
            SiteConstants: SiteConstants,
            SH041_PART:'sh041',
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[],
            isCCInputPostalShow:false,
            
            isSearchOkurinushiList:false,
            isSearchOkurinushiCompList:false,
            cc212Prop:{},
            cc211Prop:{},
            tdkIndex:0,
            debouncedChangeQtyMap:{},
            getGiftCd:null,
            descriptionInfo:[],
            NO_CART_ERR : "001",
            site: "",
            tdkInfoFlg : false,
            paySkipFlg : false,
            confirmFlg : false,
            completeFlg : false,
            showBetuOrder : false,
            isLoading: false,
            getImageOpenNewWindow: common.getImages('openNewWindow'),
            queryData : null,
            sh060 : {},

        }
    },
    /* 
    * Initialize
    */
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        var tranferdata = {};
        if (sessionStorage['sh041TranferData']) {
          tranferdata = JSON.parse(sessionStorage['sh041TranferData']);
          sessionStorage.removeItem('sh041TranferData');
        }

        if (_this.ptInitData) {
            _this.isLoading = true;
            try {
                if (_this.ptInitData.status != 'OK') {
                    if(_this.ptInitData.respCode == _this.NO_CART_ERR){
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query:{pageNo:2}});
                        return;
                    }
                }

                _this.dataInit = _this.ptInitData;
                _this.reqModel = Object.assign({}, _this.reqModel, _this.ptInitData.reqModel);

                if(_this.reqModel.tdkFlg == '3') {
                    _this.reqModel.radioGroup ='2';
                } else if(_this.reqModel.tdkFlg == '1') {
                    _this.reqModel.radioGroup ='1';
                }

                if (_this.reqModel.tdkMSeq == 1 && _this.dataInit.tdkCount == 1) {
                    _this.reqModel.radioGroup ='2';
                }

                _this.tdkInfoFlg = true;
                if (_this.dataInit.paySkipFlg == 0) {
                    _this.paySkipFlg = true;
                }
                if (_this.dataInit.tdkMyAddrFlg == 1) {
                    _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                    _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                    _this.reqModel.tdkNm3 = _this.reqModel.kokyakuNm3;
                    _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1 ;
                    _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                    _this.reqModel.tdkKana3 = _this.reqModel.kokyakuKana3;
                }
                //代理注文者の場合
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == null) {
                    _this.reqModel.radioGroup3 = '1'
                }
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == 2) {
                    _this.showBetuOrder = true;
                }
                _this.reqModel.dairiInputKbn = _this.dataInit.dairiInputKbn;
                _this.reqModel.dairiOrderKbn = _this.dataInit.dairiOrderKbn;
                _this.confirmFlg = true;
                _this.completeFlg = true;
                // 説明マスタ
                _this.descriptionInfo = _this.dataInit.descriptionInfo;
                // サイトメールを説明マスタに入れ込む
                _this.descriptionInfo[2] = _this.descriptionInfo[2].replace("[1]", _this.dataInit.siteMail);
                if (_this.ptInitData.siteFlg!=1) _this.siteFlg = 0;

                if (_this.reqModel.radioGroup3 == undefined) _this.reqModel.radioGroup3 = '1';

                if (tranferdata && tranferdata.reqModel) {
                    //DBから取得した最新のデータで上書きする
                    for(var i=0;i<tranferdata.reqModel.tdkInfoList.length;i++){
                        var tdkInfo = tranferdata.reqModel.tdkInfoList[i];
                        for(var j=0;j<tdkInfo.itemList.length;j++){
                            var itemTdk = tdkInfo.itemList[j];
                            itemTdk.noshiInfo = _this.reqModel.tdkInfoList[i].itemList[j].noshiInfo;
                        }
                    }
                    _this.reqModel = Object.assign(_this.reqModel, tranferdata.reqModel);
                }
                if (tranferdata && tranferdata.dataInit) {
                    _this.dataInit = Object.assign(_this.dataInit, tranferdata.dataInit);
                }

                // オプション50776 ON 時: 送り主入力欄の開閉状態を初期化
                if (_this.dataInit.okuriInputKaiheiOption == 1) {
                    _this.reqModel.tdkInfoList.forEach(function(tdk) {
                        _this.$set(tdk, 'csmEditOpen', false);
                    });
                }
                // 送主情報の変更ボタンの場合、チェックを入れる
                if (_this.scrollId == '3' && _this.dataInit.kokyakuNo != 999999999) {
                    //console.log(_this.reqModel.tdkInfoList);
                    //console.log('_this.tdkSeq'+_this.tdkSeq);
                    if(_this.dataInit.cartSplitUseFlg != 1){
                        //カート分割しない場合
                        var tdkInfo = _this.reqModel.tdkInfoList[_this.tdkSeq]
                    } else {
                        //カート分割する場合
                        //_this.tdkSeqはqueryで渡されてきた最小のtdkSeq
                        var tdkInfo = _this.reqModel.tdkInfoList.find(item => item.tdkSeq == _this.tdkSeq);
                        //_this.tdkSeqを探してなければ、一番小さいitem.tdkSeqを使用して取得する
                        if (!tdkInfo) {
                            tdkInfo = _this.reqModel.tdkInfoList.reduce((minItem, current) => {
                                return (!minItem || current.tdkSeq < minItem.tdkSeq) ? current : minItem;
                            }, null);
                        }
                    }
                    tdkInfo.okuriNushiCheckBox = 1;
                    if (_this.dataInit.okuriInputKaiheiOption == 1) {
                        _this.$set(tdkInfo, 'csmEditOpen', true);
                    }
                }
                // 注文内容確認画面から遷移する場合、押された変更ボタンによって表示位置を変更する。
                _this.$nextTick(() => {
                    _this.scroll();
                });

                _this.$forceUpdate();
            } catch (error) {
                common.errorAPI(error);
            } finally {
                _this.isLoading = false;
            }
        } else {
            _this.isLoading = true;
            axios.get(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_INIT).then(function(response) {
                if (response.data.status != 'OK') {
                    if(response.data.respCode == _this.NO_CART_ERR) {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 2}});
                        return;
                    }
                }

                _this.dataInit = response.data;
                _this.reqModel = Object.assign({}, _this.reqModel, response.data.reqModel);

                if(_this.reqModel.tdkFlg == '3'){
                    _this.reqModel.radioGroup ='2';
                } else if(_this.reqModel.tdkFlg == '1'){
                    _this.reqModel.radioGroup ='1';
                }
                if (_this.reqModel.tdkMSeq == 1 && _this.dataInit.tdkCount == 1) {
                    _this.reqModel.radioGroup ='2';
                }
                _this.tdkInfoFlg = true;
                if (_this.dataInit.paySkipFlg == 0){
                    _this.paySkipFlg = true;
                }
                if (_this.dataInit.tdkMyAddrFlg == 1) {
                    _this.reqModel.tdkNm1 = _this.reqModel.kokyakuNm1;
                    _this.reqModel.tdkNm2 = _this.reqModel.kokyakuNm2;
                    _this.reqModel.tdkNm3 = _this.reqModel.kokyakuNm3;
                    _this.reqModel.tdkKana1 = _this.reqModel.kokyakuKana1 ;
                    _this.reqModel.tdkKana2 = _this.reqModel.kokyakuKana2;
                    _this.reqModel.tdkKana3 = _this.reqModel.kokyakuKana3;
                }
                //代理注文者の場合
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == null) {
                    _this.reqModel.radioGroup3 = '1'
                }
                if (_this.dataInit.dairiInputKbn == '1' && _this.reqModel.radioGroup3 == 2) {
                    _this.showBetuOrder = true;
                }
                _this.reqModel.dairiInputKbn = _this.dataInit.dairiInputKbn;
                _this.reqModel.dairiOrderKbn = _this.dataInit.dairiOrderKbn;
                _this.confirmFlg = true;
                _this.completeFlg = true;
                // 説明マスタ
                _this.descriptionInfo = _this.dataInit.descriptionInfo;
                // サイトメールを説明マスタに入れ込む
                _this.descriptionInfo[2] = _this.descriptionInfo[2].replace("[1]", _this.dataInit.siteMail);
                if(response.data.siteFlg!=1) _this.siteFlg = 0;

                if(_this.reqModel.radioGroup3 == undefined) _this.reqModel.radioGroup3 = '1';


                if(tranferdata && tranferdata.reqModel){
                    //DBから取得した最新のデータで上書きする
                    for(var i=0;i<tranferdata.reqModel.tdkInfoList.length;i++){
                        var tdkInfo = tranferdata.reqModel.tdkInfoList[i];
                        for(var j=0;j<tdkInfo.itemList.length;j++){
                            var itemTdk = tdkInfo.itemList[j];
                            itemTdk.noshiInfo = _this.reqModel.tdkInfoList[i].itemList[j].noshiInfo;
                        }
                    }
                    _this.reqModel = Object.assign(_this.reqModel, tranferdata.reqModel);
                }
                if(tranferdata && tranferdata.dataInit){
                    _this.dataInit = Object.assign(_this.dataInit, tranferdata.dataInit);
                }
                // オプション50776 ON 時: 送り主入力欄の開閉状態を初期化
                if (_this.dataInit.okuriInputKaiheiOption == 1) {
                    _this.reqModel.tdkInfoList.forEach(function(tdk) {
                        _this.$set(tdk, 'csmEditOpen', false);
                    });
                }
                // 送主情報の変更ボタンの場合、チェックを入れる
                if (_this.scrollId == '3' && _this.dataInit.kokyakuNo != 999999999) {
                    var tdkInfo = _this.reqModel.tdkInfoList[_this.tdkSeq]
                    tdkInfo.okuriNushiCheckBox = 1;
                    if (_this.dataInit.okuriInputKaiheiOption == 1) {
                        _this.$set(tdkInfo, 'csmEditOpen', true);
                    }
                }
                // 注文内容確認画面から遷移する場合、押された変更ボタンによって表示位置を変更する。
                _this.$nextTick(() => {
                    console.log('scroll :scrollId='+_this.scrollId);
                    _this.scroll();
                });

                _this.$forceUpdate();
                _this.isLoading = false;
            }).catch(function(error) {
                _this.isLoading = false;
                common.errorAPI(error);
            });
        }
        
        EventBus.$on("closed", function() {
            _this.isZipMsgAlert = false;
            _this.isUpdCartQtyAlert = false;
            _this.isItemCntZeroMsgAlert = false;
            _this.isItemCntZeroOfOneTdkMsgAlert = false;
            _this.isSearchOkurinushiList = false;
            _this.isSearchOkurinushiCompList = false;
            _this.isErrorAlert = false;
        });
        EventBus.$on('closed2', function(msgConfirm){
            if(msgConfirm==_this.$t("sh041.labels.zipCodeDoesNotExist")) {
                _this.isZipRequiredMsgClose();
            }
        });

    },
    /* 
    * Computed
    */
    computed: {
        /* 送り主チェックONの件数（オプション50776） */
        csmCheckedCount: function() {
            if (!this.reqModel.tdkInfoList) return 0;
            return this.reqModel.tdkInfoList.filter(function(tdk) { return tdk.okuriNushiCheckBox == 1; }).length;
        },
        /* 送り主入力欄が全て開いているか（オプション50776） */
        allCsmEditOpen: function() {
            var targets = this.reqModel.tdkInfoList ? this.reqModel.tdkInfoList.filter(function(tdk) { return tdk.okuriNushiCheckBox == 1; }) : [];
            if (targets.length === 0) return false;
            return targets.every(function(tdk) { return tdk.csmEditOpen; });
        },
        /* 送り主入力欄が全て閉じているか（オプション50776） */
        allCsmEditClosed: function() {
            var targets = this.reqModel.tdkInfoList ? this.reqModel.tdkInfoList.filter(function(tdk) { return tdk.okuriNushiCheckBox == 1; }) : [];
            if (targets.length === 0) return false;
            return targets.every(function(tdk) { return !tdk.csmEditOpen; });
        },
    },
    /* 
    * Methods
    */
    methods: {
        furiwakeQty: function(sItemCd,seqNo) {
            var _this = this;
            
            var furiwakeQty = 0;
            if(_this.reqModel.tdkInfoList == null || _this.reqModel.tdkInfoList == undefined) return furiwakeQty;

            for (var i = 0; i < _this.reqModel.tdkInfoList.length; i++) {
                var tdkInfo = _this.reqModel.tdkInfoList[i];
                for (var j = 0; j < tdkInfo.itemList.length; j++) {
                    var itemTdk = tdkInfo.itemList[j];
                    if (itemTdk.itemCd == sItemCd && itemTdk.orderLineNo == seqNo) {
                        furiwakeQty = furiwakeQty + parseInt(common.stringNvl(itemTdk.qtySelected, '0'));
                    }
                }
            }
            return furiwakeQty;
        },

        getQtyOptions: function(product) {
            var options = [0];
            // 上限のみプルダウンに反映（下限は制御なし）
            var maxQty = parseInt(common.stringNvl(product.buyLimitSuMax, '0'), 10);
            var syukkaNum = parseInt(common.stringNvl(product.syukkaNum, '1'), 10);

            if (isNaN(maxQty) || maxQty <= 0) {
                maxQty = 100;
            }
            if (isNaN(syukkaNum) || syukkaNum <= 0) {
                syukkaNum = 1;
            }

            for (var qty = syukkaNum; qty <= maxQty; qty += syukkaNum) {
                options.push(qty);
            }

            var currentQty = parseInt(common.stringNvl(product.qtySelected, '0'), 10);
            if (!isNaN(currentQty) && currentQty > 0 && options.indexOf(currentQty) === -1) {
                options.push(currentQty);
            }

            options.sort(function(a, b) {
                return a - b;
            });

            return options;
        },
        
        /*
        * 前のページへ戻るボタン押下処理
        */
        goBack:function(){
            var _this = this;
            var backPageNo = _this.sh060.backPageNo || 20; // 戻り先ページNOが設定されていなければ、複数届先選択画面へ戻る
            // 戻り先画面へ
            _this.$router.push({name: _this.SiteConstants.PG010MAIN, query: {pageNo: backPageNo}});
        },

        /* 
        * [次へ]ボタンを押下
        */
        doNext: function() {
            var _this = this;
            _this.reqModel.tdkInfoList = _this.reqModel.tdkInfoList;

            // お届け先情報の商品数量チェック（商品合計が0の場合、エラー）
            for (var i = 0; i < _this.reqModel.tdkInfoList.length; i++) {
                var tdkInfo = _this.reqModel.tdkInfoList[i];
                var tdkItemQty = 0;
                for (var j = 0; j < tdkInfo.itemList.length; j++) {
                    var itemTdk = tdkInfo.itemList[j];
                    tdkItemQty = tdkItemQty + parseInt(common.stringNvl(itemTdk.qtySelected, '0'));
                }
                if(tdkItemQty == 0){
                    _this.itemCntZeroOfOneTdkMsg = _this.setErrorMsg(tdkInfo, i+1, 'qty');
                    _this.isItemCntZeroOfOneTdkMsgAlert = true;
                    return;
                }
            }

            //振分数量チェック
            if(_this.dataInit.cartInfoList && _this.dataInit.cartInfoList.length>0){
                for(var i=0;i<_this.dataInit.cartInfoList.length;i++){
                    var cartInfo = _this.dataInit.cartInfoList[i];
                    if(_this.furiwakeQty(cartInfo.M_ITEM_CD,cartInfo.SEQ) != cartInfo.QTY && cartInfo.BINSYU_KBN != '90'){
                        _this.isUpdCartQtyAlert= true;
                        return;
                    }
                }
            }

            _this.submit();
        },

        /* 
        * エラーメッセージの編集処理
        */
        setErrorMsg: function(tdkInfo, index, type) {
            var _this = this;
            var errorMsg;
            let tdkTitle = tdkInfo.tdkTitle;
            if (_this.dataInit.tdkKeisyouPullDownFlg == 1 && tdkInfo.tdkFlg == '0'){
                if (tdkTitle != ""){
                    const tdkHyoujiKeisyo = _this.dataInit.tdkHyoujiKeisyoList.find(item => item.KEY == tdkTitle);
                    if (tdkHyoujiKeisyo) {
                        tdkTitle = tdkHyoujiKeisyo.VALUE;
                    }
                }
            }
            if(tdkInfo.tdkFlg === '1') {
                errorMsg = '届先' + index + '件目（注文者様宛）' +'の';
            } else {
                errorMsg = '届先' + index + '件目(' + tdkInfo.tdkNm1 + ' ' + tdkInfo.tdkNm2 + ' ' + tdkInfo.tdkNm3 + tdkTitle +'宛）' +'の';
            }
            if(type === 'qty') {
                errorMsg = errorMsg + _this.$t("sh041.messages.tdkItemZeroError");
            }
            return errorMsg;
        },

        /* 
        * カート数量更新
        */
        updCartQty: function() {
            var _this = this;

            this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH041_PART);

            //振分数量で、カート数量を更新する
            for(var i=0;i<_this.dataInit.cartInfoList.length;i++){
                var cartInfo = _this.dataInit.cartInfoList[i];
                cartInfo.QTY = _this.furiwakeQty(cartInfo.M_ITEM_CD,cartInfo.SEQ);
            }
            var reqModel = {
                cartInfoList: _this.dataInit.cartInfoList
            };
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_AJAX, reqModel).then(function(response) {
                _this.$emit("event-loading", false);
                if(response.data.status=="OK"){
					_this.isUpdCartQtyAlert = false;
                    _this.submit();
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH041_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },

        submit:function(){
            var _this = this;
            _this.isItemCntZeroMsgAlert = false;
            _this.isItemCntZeroOfOneTdkMsgAlert = false;

            _this.reqModel.siteFlg = _this.siteFlg;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.SH041_PART);
            _this.reqModel.itemTdkList = _this.dataInit.itemTdkList;

            if (_this.dataInit.tdkCount > 1 && _this.reqModel.tdkNo != 0) {
                _this.reqModel.radioGroup = 6;
            }

            
            axios.post(_this.$UrlConstants.ECSITE +_this.$UrlConstants.SH041 + _this.$UrlConstants.DO_UPDATE, _this.reqModel).then(function(response) {
                if(response.data.status=="OK"){
                    sessionStorage.removeItem('totalPointKin');
                    // 配送・ギフト設定画面へ
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 24, backPageNo: 28}});
                    _this.$emit("event-loading", false);
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    _this.isModalShow = false;
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH041_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                common.scrollTop();
            });
        },
        gotobak:function(){
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22}});
        },
        setAddrValue:function(data){
            var _this = this;
            var idx = data.idx;
            var tdkInfo = _this.reqModel.tdkInfoList[idx];
            var addr1 = data.addr.ALL_ADDR?data.addr.ALL_ADDR:"";
            
            var kenCd = data.kenCd+"";
            tdkInfo.csmAddr1 = addr1;
            tdkInfo.csmKen = kenCd;
        
            _this.isCCInputPostalShow = false;
            _this.$forceUpdate();
        },
        nextPage: function(){
			var _this = this;
			common.clearMessage(_this.listIdErr,"","sh041")
			_this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 20}});
		},
        setAddr:function(idx){
            var _this = this;
            _this.tdkIndex = idx;
            var tdkInfo = _this.reqModel.tdkInfoList[idx];
            var zip = tdkInfo.csmZip;
            
            if(!zip) {
                _this.isZipMsgAlert = true;
                _this.zipMsg = _this.$t("sh041.labels.zipCodeIsMandatory");
				return;
			}
            var zipArr = zip.split("-");
            var zip1 = "";
            var zip2 = "";
            if (zipArr.length == 2) {
                zip1 = zipArr[0];
                zip2 = zipArr[1];
            }else{
                zip1 = zip.substr(0,3);
                zip2 = zip.substr(3);
                tdkInfo.csmZip=zip1+"-"+zip2;
            }
            var reqModel = {
                idx:idx,
                tdkZip1:zip1,
                tdkZip2:zip2
            }
            _this.$emit("event-loading", true);
            axios.post(_this.$UrlConstants.POPUP +_this.$UrlConstants.CC212 + _this.$UrlConstants.GET_ADDR_INFO, reqModel).then(function(response) {
                if(response.data.kenCd!=undefined) {
                    tdkInfo.csmKen = response.data.kenCd+"";
                    tdkInfo.csmAddr1 = response.data.allAddr;
                    if(response.data.allAddr!=""){
                        var allAddr = '';

                        var splAdd = response.data.allAddr.split(",");
                        allAddr = splAdd[0] != null ? splAdd[0]:'';
                        allAddr += splAdd[1] != null ? splAdd[1]:'';
                        allAddr += splAdd[2] != null ? splAdd[2]:'';
                        var addr1 = allAddr;
                        //都道府県のプルダウンを使用しない場合
                        if(_this.dataInit.kenPulldownDispFlg == 0){
                            tdkInfo.csmAddr1 = response.data.kenNm + addr1;
                        }else{
                            tdkInfo.csmAddr1 = addr1;
                        }
                    } 
                }
                if(response.data.allAddr==""){
                    _this.isZipMsgAlert = true;
                    _this.zipMsg = _this.$t("sh041.labels.zipCodeDoesNotExist");
                } else if(response.data.allAddr=="juufuku") {
                    _this.openSub(idx, zip1, zip2);
                }

                _this.$emit("event-loading", false);
                _this.$forceUpdate();
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
                common.scrollTop();
            });
        },
        openSub:function(idx, zip1, zip2){
            var _this = this;
            _this.cc212Prop = {
                propTdkZip1:zip1,
                propTdkZip2:zip2,
                propIdx:idx,
            }
            _this.isCCInputPostalShow = true;
        },
        isZipRequiredMsgClose:function(){
            var _this = this;
            _this.isZipMsgAlert = false;
        },
        
        showModal(itemCd,itemNm) {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH030 + "/getShipYotei", itemCd+":"+itemNm).then(function(response) {
                if (response.data && response.data.inventoryItemModelLst) {
                    _this.tableData = response.data.inventoryItemModelLst;
                    _this.selectedShouhinLst = response.data.itemNmLst;
					var shouhin = response.data.colSizList.find(item => item['KEY'] === itemCd);
					_this.selectedShouhin = shouhin ? shouhin['VALUE'] : itemNm;
                    _this.isModalVisible = true;
                    _this.note = response.data.memo;
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
        },
        /*
        * 送主検索ボタン押下時
        */
        searchOkuriNushiList:function(tdkIndex){
            var _this = this;
            _this.tdkIndex = tdkIndex;
            _this.cc211Prop = {propKokyakuNo:_this.reqModel.kokyakuNo}
            _this.isSearchOkurinushiList=true;
        },
        /*
        * 注文者情報を反映する
        */
        setKokyakuInfo:function(tdkIndex){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIndex];
            tdkInfo.csmNo = '0';
            tdkInfo.csmNm1 = _this.reqModel.kokyakuNm1;
            tdkInfo.csmNm2 = _this.reqModel.kokyakuNm2;
            tdkInfo.csmNm3 = _this.reqModel.kokyakuNm3;
            tdkInfo.csmKana1 = _this.reqModel.kokyakuKana1;
            tdkInfo.csmKana2 = _this.reqModel.kokyakuKana2;
            tdkInfo.csmKana3 = _this.reqModel.kokyakuKana3;
            tdkInfo.csmZip = _this.reqModel.kokyakuZip;
            tdkInfo.csmKen = _this.reqModel.kokyakuKen;
            tdkInfo.csmAddr1 = _this.reqModel.kokyakuAddr1;
            tdkInfo.csmAddr2 = _this.reqModel.kokyakuAddr2;
            tdkInfo.csmAddr3 = _this.reqModel.kokyakuAddr3;
            tdkInfo.csmTel = _this.reqModel.kokyakuTel;
            //_this.reqModel.okuriHyoujiKeisyo = data.value.TDK_KEISYOU;
            _this.$forceUpdate();
        },
        /*
        * 送り主を一括反映する
        */
        setIkkatuOkuriInfo:function(tdkIndex){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIndex];
            if (common.isNullItem(tdkInfo.csmNm1) || common.isNullItem(tdkInfo.csmNm2) || common.isNullItem(tdkInfo.csmZip) || common.isNullItem(tdkInfo.csmKen) || common.isNullItem(tdkInfo.csmAddr1) || common.isNullItem(tdkInfo.csmTel)) {
                _this.isZipMsgAlert = true;
                _this.zipMsg = _this.$t("sh041.messages.okuriError");
                return;
            }
            for(let j = 0; j < _this.reqModel.tdkInfoList.length; j++) {
                const tdkinfoList = _this.reqModel.tdkInfoList[j];
                if (tdkIndex != j) {
                    tdkinfoList.csmNo = tdkInfo.csmNo;
                    tdkinfoList.okuriNushiCheckBox = 1;
                    if (_this.dataInit.okuriInputKaiheiOption == 1) {
                        tdkinfoList.csmEditOpen = false;
                    }
                    tdkinfoList.csmNm1 = tdkInfo.csmNm1;
                    tdkinfoList.csmNm2 = tdkInfo.csmNm2;
                    tdkinfoList.csmNm3 = tdkInfo.csmNm3;
                    tdkinfoList.csmKana1 = tdkInfo.csmKana1;
                    tdkinfoList.csmKana2 = tdkInfo.csmKana2;
                    tdkinfoList.csmKana3 = tdkInfo.csmKana3;
                    tdkinfoList.csmZip = tdkInfo.csmZip;
                    tdkinfoList.csmKen = tdkInfo.csmKen;
                    tdkinfoList.csmAddr1 = tdkInfo.csmAddr1;
                    tdkinfoList.csmAddr2 = tdkInfo.csmAddr2;
                    tdkinfoList.csmAddr3 = tdkInfo.csmAddr3;
                    tdkinfoList.csmTel = tdkInfo.csmTel;
                }
            }
            _this.$forceUpdate();
        },
        
        /*
        * 送主情報をセット
        */
        setOkurinushiValueCc211(data){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[_this.tdkIndex];
            tdkInfo.csmNo = data.value.TDK_NO;
            tdkInfo.csmNm1 = data.value.TDK_NM1;
            tdkInfo.csmNm2 = data.value.TDK_NM2;
            tdkInfo.csmNm3 = data.value.TDK_NM3;
            tdkInfo.csmKana1 = data.value.TDK_KANA1;
            tdkInfo.csmKana2 = data.value.TDK_KANA2;
            tdkInfo.csmKana3 = data.value.TDK_KANA3;
            tdkInfo.csmZip = data.value.TDK_ZIP;
            tdkInfo.csmKen = data.value.TDK_KEN;
            tdkInfo.csmAddr1 = data.value.KEN_NM + data.value.TDK_ADDR1;
            //都道府県のプルダウンを使用しない場合
            if(_this.dataInit.kenPulldownDispFlg == 0){
                tdkInfo.csmAddr1 = data.value.KEN_NM + data.value.TDK_ADDR1;
            }else{
                tdkInfo.csmAddr1 = data.value.TDK_ADDR1;
            }
            tdkInfo.csmAddr2 = data.value.TDK_ADDR2;
            tdkInfo.csmAddr3 = data.value.TDK_ADDR3;
            tdkInfo.csmTel = data.value.TDK_TEL1;
            tdkInfo.csmTitle = data.value.TDK_KEISYOU;
            //_this.reqModel.okuriHyoujiKeisyo = data.value.TDK_KEISYOU;
            _this.$forceUpdate();
        },
        /*
        * 商品数量変更
        */
        changeQtyDebounced:function(tdkIdx,itemIdx,qtySelected){
            var _this = this;
            var key = tdkIdx + '_' + itemIdx;

            if (!_this.debouncedChangeQtyMap[key]) {
                _this.debouncedChangeQtyMap[key] = _.debounce(function(debouncedTdkIdx, debouncedItemIdx, debouncedQtySelected) {
                    _this.changeQty(debouncedTdkIdx, debouncedItemIdx, debouncedQtySelected);
                }, 500);
            }
            _this.debouncedChangeQtyMap[key](tdkIdx, itemIdx, qtySelected);
        },
        cancelDebouncedChangeQty:function(tdkIdx,itemIdx){
            var key = tdkIdx + '_' + itemIdx;
            var debouncedChangeQty = this.debouncedChangeQtyMap[key];

            if (debouncedChangeQty) {
                debouncedChangeQty.cancel();
                delete this.debouncedChangeQtyMap[key];
            }
        },
        changeQty:function(tdkIdx,itemIdx,qtySelected){
            var _this = this;
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIdx];
            var itemTdk = tdkInfo.itemList[itemIdx];
            var qty = qtySelected;

            if(! common.isNullItem(itemTdk.noshiInfo)){
                //のし枚数更新
                var reqModel = {
                    tdkSeq:tdkInfo.tdkSeq,
                    itemCd:itemTdk.itemCd,
                    itemQty:qty
                }
                _this.$emit("event-loading", true);
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH041 + "/updNoshiQty", reqModel).then(function(response) {
                    if(response.data["NOSHI_INFO"]) {
                        itemTdk.noshiInfo = response.data["NOSHI_INFO"];
                    }
                    _this.$emit("event-loading", false);
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                    common.scrollTop();
                });
            }
            _this.$forceUpdate();
        },
        /*
        * 数量プラスボタン（オプション50540 +- モード）
        */
        stepUp:function(tdkIdx, pindex){
            var _this = this;
            _this.cancelDebouncedChangeQty(tdkIdx, pindex);
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIdx];
            var itemTdk = tdkInfo.itemList[pindex];
            var current = parseInt(itemTdk.qtySelected, 10);
            if (isNaN(current) || current < 0) {
                current = 0;
            }
            itemTdk.qtySelected = current + 1;
            _this.changeQty(tdkIdx, pindex, itemTdk.qtySelected);
        },
        /*
        * 数量マイナスボタン（オプション50540 +- モード）
        * 0 未満には下がらない
        */
        stepDown:function(tdkIdx, pindex){
            var _this = this;
            _this.cancelDebouncedChangeQty(tdkIdx, pindex);
            var tdkInfo = _this.reqModel.tdkInfoList[tdkIdx];
            var itemTdk = tdkInfo.itemList[pindex];
            var current = parseInt(itemTdk.qtySelected, 10);
            if (isNaN(current) || current <= 0) {
                itemTdk.qtySelected = 0;
                _this.$forceUpdate();
                return;
            }
            itemTdk.qtySelected = current - 1;
            _this.changeQty(tdkIdx, pindex, itemTdk.qtySelected);
        },
        /*
        * しの情報設定
        */
        doSetShiNo:function(tdkSeq,itemCd,itemQty,itemNm1){
            var tranferdata = {}; 
            tranferdata.reqModel=this.reqModel;
            tranferdata.dataInit=this.dataInit;
            
            sessionStorage['sh041TranferData'] = JSON.stringify(tranferdata);
            this.$router.push(
                { name: this.SiteConstants.PG010MAIN
                , params: {dispOnly : 0,backPageNo:28,tdkNo:tdkSeq,itemCd:itemCd,qty:itemQty,itemNm1:itemNm1,kokyakuNm1:''}
                , query: {pageNo: 26}
                }
            );
        },

        /*
        * スクロール
        * 注文内容確認画面でどの「変更」を押したかによって、スクロールさせる
        */
        scroll:function(){
            var eleId;
            switch(this.scrollId) {
                case '0':
                    // お届け先情報
                    eleId = 'tdkInfo_'+this.tdkSeq;
                    break;
                case '1':
                    // 配送希望日時
                    eleId = 'tdkYmdScroll_'+this.tdkSeq;
                    break;
                case '2':
                    // ギフト設定
                    eleId = 'tdkGiftScroll_'+this.tdkSeq;
                    break;
                case '3':
                    // 送主設定
                    eleId = 'tdkOkuriScroll_'+this.tdkSeq;
                    break;
                case '4':
                    // 備考欄
                    eleId = 'bikoScroll_'+this.tdkSeq;
                    break;
                default:
                    eleId = '';
                    break;
            }
            let element = document.getElementById(eleId);
            if (element != null){
                document.getElementById(eleId).scrollIntoView();
            }
        },

        getErrImage(event) {
            event.target.src = common.getImgDefault();
        },
        /* 
        * 送り主入力欄を全て開く（オプション50776）
        */
        openAllCsmEdit: function() {
            var _this = this;
            _this.reqModel.tdkInfoList.forEach(function(tdk) {
                if (tdk.okuriNushiCheckBox == 1) {
                    _this.$set(tdk, 'csmEditOpen', true);
                }
            });
            _this.$forceUpdate();
            _this.$nextTick(() => {
                common.scrollTop();
            });
        },
        /* 
        * 送り主入力欄を全て閉じる（オプション50776）
        */
        closeAllCsmEdit: function() {
            var _this = this;
            _this.reqModel.tdkInfoList.forEach(function(tdk) {
                if (tdk.okuriNushiCheckBox == 1) {
                    _this.$set(tdk, 'csmEditOpen', false);
                }
            });
            _this.$forceUpdate();
            _this.$nextTick(() => {
                common.scrollTop();
            });
        },
        /* 
        * 送り主入力欄OKボタン（バリデーション付き閉じる）（オプション50776）
        */
        closeCsmEdit: function(tdk, index) {
            var _this = this;
            var hasError = false;
            // 名前（常に必須）
            if (!tdk.csmNm1) hasError = true;
            // フリガナ（kanaHissuFlg == 1 の場合のみ必須）
            if (_this.dataInit.kanaHissuFlg == 1 && !tdk.csmKana1) hasError = true;
            // 郵便番号（常に必須）
            if (!tdk.csmZip) hasError = true;
            // 都道府県（kenPulldownDispFlg == 1 の場合のみ必須）
            if (_this.dataInit.kenPulldownDispFlg == 1 && !tdk.csmKen) hasError = true;
            // 住所1（常に必須）
            if (!tdk.csmAddr1) hasError = true;
            // 住所2（BtoCのみ、addr2Flg == 1 && addr2HissuFlg == 1 の場合のみ必須）
            if (_this.dataInit.siteFlg != 1 && _this.dataInit.addr2Flg == 1 && _this.dataInit.addr2HissuFlg == 1 && !tdk.csmAddr2) hasError = true;
            // 住所3（BtoCのみ、addr3Flg == 1 && addr3HissuFlg == 1 の場合のみ必須）
            if (_this.dataInit.siteFlg != 1 && _this.dataInit.addr3Flg == 1 && _this.dataInit.addr3HissuFlg == 1 && !tdk.csmAddr3) hasError = true;
            // 電話番号（常に必須）
            if (!tdk.csmTel) hasError = true;
            if (hasError) {
                _this.$set(tdk, 'csmOkError', true);
                _this.$forceUpdate();
                return;
            }
            _this.$set(tdk, 'csmOkError', false);
            _this.$set(tdk, 'csmEditOpen', false);
        },
        /* 
        * 送り主チェックボックス変更時の開閉制御（オプション50776）
        */
        onCsmCheckChange: function(tdk) {
            if (tdk.okuriNushiCheckBox == 1 && this.dataInit.okuriInputKaiheiOption == 1) {
                this.$set(tdk, 'csmEditOpen', true);
            }
        },

    },

    created() {
        var _this = this;
        _this.scrollId ='';
        var queryData = _this.$route.query;
        if (Object.keys(queryData).length > 0) {
            _this.scrollId = queryData.scrollId;
            _this.tdkSeq = queryData.tdkSeq;
            _this.sh060 = queryData;
        }
    }
}
</script>

<style scoped>
.sh041-item-img {
  display: block;
  width: 60px;
  height: 60px;
  object-fit: contain;
}
/* 届先・送主情報詳細表示（オプション） */
#sh041 #tdkInfo .divCsmNm > div {
  flex-wrap: wrap;
  align-items: flex-start;
}
#sh041 #tdkInfo .divCsmNm > div > p {
  flex-basis: 100%;
}
/* 送り主 読み取り専用表示（オプション50776） */
#sh041 #tdkInfo .divCsmNm .sh041-csm-readonly {
  padding: 5px 0;
  flex-basis: 100%;
  flex-direction: column;
  align-items: flex-start;
}
#sh041 #tdkInfo .divCsmNm .sh041-csm-readonly dt {
  font-weight: normal;
}
/* 送り主の内容を編集ボタン（オプション50776） */
.sh041-btn-csm-edit {
  margin-left: 10px;
  padding: 2px 10px;
  font-size: 12px;
  cursor: pointer;
}
/* 送り主入力欄OKボタンエリア（オプション50776） */
.sh041-csm-ok-area {
  text-align: right;
  margin: 10px 0;
}
.sh041-btn-csm-ok {
  padding: 5px 30px;
  cursor: pointer;
}
/* 送り主入力欄 一括ボタンエリア（オプション50776） */
.sh041-csm-bulk-area {
  text-align: right;
  margin: 10px 0;
}
.sh041-btn-csm-bulk {
  margin-left: 10px;
  padding: 5px 15px;
  cursor: pointer;
}
/* 送り主入力欄 エラー表示（OKボタン押下時バリデーション） */
.sh041-err-input {
  border: 1px solid red !important;
}
.sh041-csm-ok-error {
  margin-right: 10px;
  font-size: 12px;
}
/* 数量入力欄（オプション50540） */
.sh041-inp-qty-text {
  width: 60px;
  padding: 2px 5px;
  text-align: right;
}
</style>
